import { useContext, useEffect, useState } from 'react';
import { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';

// import './ImageField.scss';

const NumberField = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const customisationFieldData = getCustomisationFieldData(campaignContext.campaignData, props.selectedFeatureNode.id, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null);
    console.log("NumberField: customisationFieldData:", customisationFieldData, props, campaignContext.campaignData, props.selectedFeatureNode.id, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null);

    const showHiddenDropdownVals = customisationFieldData?.type === 'slider';
    const hiddenDropDownVals = [];
    if (showHiddenDropdownVals) {
        const hiddenDropDownStep = Math.round(((customisationFieldData?.maxVal ?? 100) - (customisationFieldData?.minVal ?? 0)) / 10);
        hiddenDropDownVals.push(customisationFieldData?.minVal ?? 0);
        for (let val = (customisationFieldData?.minVal ?? 0) + hiddenDropDownStep; val < (customisationFieldData?.maxVal ?? 100); val += hiddenDropDownStep) {
            hiddenDropDownVals.push(Math.round(val));
        }
        hiddenDropDownVals.push(customisationFieldData?.maxVal ?? 100);
    }

    const [currentValue, setCurrentValue] = useState(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode));
    useEffect(() => {
        setCurrentValue(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode));
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Number'}</div>
            <ModuleNumericalInput
                value={currentValue}
                fieldId={'number-field'}
                enabled={props.isEnabled}
                editable={true}
                onChange={(fieldId, value) => {
                    WORKING_ON_NODE_DATA.fieldData = fieldData;
                    WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
                    updateCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                    setCurrentValue(value);
                    props?.forceUpdateComponent?.();
                }}
                hiddenDropDown={showHiddenDropdownVals}
                hiddenDropDownOptions={hiddenDropDownVals}
                dropDownValue={currentValue}
            />
        </>
    );
};

export default NumberField;
